import { useState, useEffect } from 'react'
import { SignIn, useClerk } from '@clerk/react'

function ClerkSetupMessage() {
  return (
    <div className="card rounded-4 shadow-lg border-0" style={{ maxWidth: 440, width: '100%' }}>
      <div className="card-body p-5">
        <h5 className="fw-bold mb-3 text-center">
          <i className="bi bi-gear-fill text-primary me-2"></i>Clerk Setup Required
        </h5>
        <p className="text-muted small mb-3">
          To enable Google &amp; Microsoft login, add your Clerk publishable key:
        </p>
        <ol className="small text-muted mb-4">
          <li className="mb-2">Go to <a href="https://clerk.com" target="_blank" rel="noreferrer" className="fw-semibold">clerk.com</a> and create a free account</li>
          <li className="mb-2">Create an application → enable <strong>Google</strong> and <strong>Microsoft</strong> social connections</li>
          <li className="mb-2">Copy your <strong>Publishable Key</strong> (starts with <code>pk_test_</code> or <code>pk_live_</code>)</li>
          <li className="mb-2">Create <code>client/.env</code>:
            <pre className="bg-light rounded p-2 mt-1 small" style={{ fontSize: '0.72rem' }}>
              VITE_CLERK_PUBLISHABLE_KEY=pk_test_xxxxxxxx
            </pre>
          </li>
          <li>Rebuild and redeploy</li>
        </ol>
        <a
          href="https://clerk.com"
          target="_blank"
          rel="noreferrer"
          className="btn btn-primary w-100"
          style={{ background: 'linear-gradient(135deg, #0d6efd, #6610f2)', border: 'none' }}
        >
          <i className="bi bi-box-arrow-up-right me-2"></i>Get Free Clerk Key
        </a>
      </div>
    </div>
  )
}

function LoginContent() {
  const { loaded } = useClerk()
  const [timedOut, setTimedOut] = useState(false)

  useEffect(() => {
    // If Clerk hasn't loaded within 5 seconds, show setup instructions
    const t = setTimeout(() => setTimedOut(true), 5000)
    if (loaded) clearTimeout(t)
    return () => clearTimeout(t)
  }, [loaded])

  if (!loaded && timedOut) {
    return <ClerkSetupMessage />
  }

  return (
    <SignIn
      routing="path"
      path="/login"
      signUpUrl="/register"
      fallbackRedirectUrl="/dashboard"
      appearance={{
        elements: {
          rootBox: { width: '100%', maxWidth: 440 },
          card: {
            borderRadius: '1rem',
            boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
            border: 'none',
          },
          headerTitle: { display: 'none' },
          headerSubtitle: { display: 'none' },
          socialButtonsBlockButton: {
            borderRadius: '0.5rem',
            fontWeight: 600,
          },
          formButtonPrimary: {
            background: 'linear-gradient(135deg, #0d6efd, #6610f2)',
            borderRadius: '0.5rem',
            fontWeight: 600,
          },
          footerActionLink: { color: '#0d6efd', fontWeight: 600 },
        },
      }}
    />
  )
}

export default function Login() {
  return (
    <div
      className="min-vh-100 d-flex flex-column align-items-center justify-content-center gap-4"
      style={{ background: 'linear-gradient(135deg, #0d6efd 0%, #6610f2 100%)' }}
    >
      {/* Branding */}
      <div className="text-center text-white">
        <div
          className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
          style={{ width: 72, height: 72, background: 'rgba(255,255,255,0.2)', backdropFilter: 'blur(8px)' }}
        >
          <i className="bi bi-heart-pulse-fill fs-2"></i>
        </div>
        <h3 className="fw-bold mb-1">ConsultAiDoc</h3>
        <p className="opacity-75 small mb-0">AI Medical Consultation Platform</p>
      </div>

      {/* Clerk SignIn widget (with setup fallback) */}
      <LoginContent />
    </div>
  )
}
